import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { useSnackbar } from "notistack";
import styles from "./styles.module.scss";

import { Pannel, Loading } from "../../../../primitives";
import { useModelPopup } from "../../../../../common/hooks";
import { Icon, mdSize, smSize } from "../../../../../common/icon";
import classNames from "classnames";
import ChartCompanyItem from "../../../../companies/companyMain/chartsWrapper/chartCompanyItem/index";

import {
  themesCompanyAddAttempt,
  themesCompanyGetAttempt,
} from "../overviewTab.action";

const KyndrilCompaniesBlock = ({}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
    themesReducer: {
      themesMainReducer: { currentThemeData },
      themesOverviewReducer: { companyList, loadingCompany, companiesPageMeta },
    },
  } = useSelector((state) => state);
  const [sortingConfig, setSortingConfig] = useState(null);

  const [seeAll, setSeeAll] = useState(false);
  const [isCompaniesOpened, setIsCompaniesIsOpenned] = useState(true);

  const [pageSetting, setPageSetting] = useState({
    pageSize: 10,
    current: 1,
    hideOnSinglePage: true,
    showTitle: false,
    total: companiesPageMeta.total || 0,
  });
  const [chunkToShow, setChunkToShow] = useState([]);

  const handlePagingChange = (page) => {
    setPageSetting((prev) => ({
      ...prev,
      total: companiesPageMeta.total,
      current: page,
    }));
  };

  useEffect(() => {
    if (companyList?.length && !seeAll) {
      setChunkToShow(companyList.slice(0, 6));
    }
    if (pageSetting?.current && companyList?.length && seeAll) {
      setChunkToShow(companyList);
    }
  }, [pageSetting?.current, companyList, seeAll]);

  useEffect(() => {
    if (selectedCouncil && currentThemeData.id) {
      dispatch(
        themesCompanyGetAttempt({
          id: currentThemeData.id,
          enqueueSnackbar,
          page: seeAll ? pageSetting.current : 1,
          items: pageSetting.pageSize,
        })
      );
    }
  }, [selectedCouncil, pageSetting.current, seeAll]);

  const drawSortingIcon = useCallback(
    (col) => {
      if (!sortingConfig) return null;

      if (sortingConfig?.activeColumn === col) {
        return (
          <div
            className={classNames(
              styles.sortIcon,
              sortingConfig.order === "desc" && styles.sortAsc
            )}
          >
            <Icon {...smSize} icon="icn-export-button" />
          </div>
        );
      }
    },
    [sortingConfig]
  );
  const makeSortingConfig = useCallback(
    (activeColumn, child) => {
      if (sortingConfig && sortingConfig?.activeColumn === activeColumn) {
        if (sortingConfig.order === "desc") {
          const newConfig = {
            activeColumn,
            order: "asc",
            child,
          };

          setSortingConfig(newConfig);
          return;
        }

        setSortingConfig({
          activeColumn: null,
          order: null,
          child,
        });

        return;
      }

      const newConfig = {
        activeColumn,
        order: "desc",
        child,
      };

      setSortingConfig(newConfig);
    },
    [sortingConfig]
  );
  if (loadingCompany) {
    return <Loading />;
  }
  return (
    <div className={styles.innovationListWrapper}>
      <div className={`d-flex flex-column mt-3`}>
        <div className={styles.listHeader}>
          <span
            onClick={() => makeSortingConfig("name")}
            className={`${styles.company} }`}
          >
            Company
            {drawSortingIcon("name")}
          </span>
          <span
            onClick={() => makeSortingConfig("total_fundings_sum")}
            className={` ${styles.funding}} `}
          >
            Total Funding
            {drawSortingIcon("total_fundings_sum")}
          </span>

          <span
            onClick={() => makeSortingConfig("partner_type")}
            className={styles.score}
          >
            Partner type
            {drawSortingIcon("partner_type")}
          </span>

          <span
            onClick={() => makeSortingConfig("council_relationship_stage_name")}
            className={` ${styles.status} }`}
          >
            Stage
            {drawSortingIcon("council_relationship_stage_name")}
          </span>

          <span
            onClick={() => makeSortingConfig("project_stage", "name")}
            className={styles.founded}
          >
            Relationship Owner
            {drawSortingIcon("project_stage")}
          </span>

          <div className="d-flex" style={{ width: "20px" }} />
          {/* {companyList.map((company) => {
            return (
              <ChartCompanyItem
                company={{ ...company, id: company.company_id }}
                selectedCouncil={selectedCouncil}
                history={history}
                dispatch={dispatch}
              />
            );
          })} */}
        </div>
      </div>
    </div>
  );
};

export default React.memo(KyndrilCompaniesBlock);
